import { Row, Col, Typography } from "antd";
import { GLOBAL_CONSTANTS, LABEL_TXT } from "../../constants/constants";
import { parseReferenceLinks } from "../../helpers/referenceLinks";
import ExpandableText from "../ExpandableText/ExpandableText";
import "./Details.scss";

const { Text } = Typography;

const formatLinkHref = (url) => {
  if (!url) return url;
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

const ReferenceLinksDetailView = ({ referenceLinks }) => {
  const links = parseReferenceLinks(referenceLinks).filter((entry) =>
    entry?.url?.trim(),
  );

  return (
    <Row
      gutter={[16, 16]}
      className="detail-container reference-links-detail"
      align="top"
    >
      <Col xs={10} md={6}>
        <Text className="label">{LABEL_TXT.ADDITIONAL_REF_LINKS}</Text>
      </Col>
      <Col xs={14} md={15}>
        {links.length === 0 ? (
          <Text className="value">{GLOBAL_CONSTANTS.NA}</Text>
        ) : (
          <div className="reference-links-list">
            {links.map((entry, index) => (
              <div key={`${entry.url}-${index}`} className="reference-link-item">
                <a
                  href={formatLinkHref(entry.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="reference-link-url"
                >
                  {entry.url}
                </a>
                <ExpandableText
                  text={entry.description}
                  className="reference-link-description"
                  textClassName="value"
                />
              </div>
            ))}
          </div>
        )}
      </Col>
      <Col xs={6} md={3} />
    </Row>
  );
};

export default ReferenceLinksDetailView;
